module.exports = __webpack_public_path__ + "static/img/200162.3a924cb7.png";